export interface UploadedFile {
  uploadedBy: string;
  originalFileName: string;
  fileName: string;
  contentType: string;
  uploadedOn: Date;
  id: number;
  downloadURL: string;
}
